const languages = {
    en: { code: 'en', nativeName: 'English'},
    es: { code: 'es', nativeName: 'Español'}
}

export default languages;